import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { cmsRoutes } from 'routes/cmsRoutes'
import { useAuthContext } from 'utils/auth'

type Props = {
  children: ReactNode
}

export const AuthGuard = ({ children }: Props) => {
  const { isAuthenticated } = useAuthContext()

  if (!isAuthenticated) {
    return <Navigate to={cmsRoutes.SIGN_IN} replace />
  }

  return <>{children}</>
}
